import { writable } from 'svelte/store';

export const projectDetail = writable({})

export const projectSaleDetails = writable({});

export const isLoaderActive = writable(false);

export const projectType = writable("");

export const isTransactionConfirmed = writable(false);

export const tokenPurchased = writable(0);

export const isCalculatingPurchaseLimit = writable(true);
